import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-paddock-svg',
  imports: [],
  templateUrl: './paddock-svg.component.html',
  styleUrl: './paddock-svg.component.css'
})
export class PaddockSvgComponent {
  @Input() width: string = '50'
  @Input() height: string = '50'
  @Input() colored: boolean = false
}
